import { useState, useEffect } from 'react';
import { urlApi } from '../helpers/functionHelpers';

const useFolio = (setFormData, formField) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFolio = async () => {
      try {
        const response = await fetch(`${urlApi}/api/folio`);
        if (!response.ok) {
          throw new Error('Error al obtener el folio');
        }
        const data = await response.json();

        // Actualiza el formData con el folio obtenido
        if (setFormData && formField) {
          setFormData((prevFormData) => ({
            ...prevFormData,
            [formField]: data.folio, // Actualiza el campo del folio
          }));
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchFolio();
  }, [setFormData, formField]);

  return { loading, error };
};

export default useFolio;
